import React, {useState, useEffect} from "react"
import {connect} from "react-redux"
import PropTypes from "prop-types"

import moment from "moment"

import {FormSection, FieldDate, Button, Field} from "~/components/"
import {Article} from "~/utils/ShelfEntities"
import {formatOptionalNumber} from "~/utils"
import history from "~/history.js"
import {useApi} from "~/hooks"
import {useTranslation} from "react-i18next"

const NewArticle = ({match, usingTestDate}) => {
  const {t} = useTranslation()
  const barcode = match.params.article_barcode
  const article = useApi(`/articles/${barcode}`)
  const [expiryDate, setExpiryDate] = useState(false)
  const [note, setNote] = useState("")
  const [serialNumber, setSerialNumber] = useState("")
  const [reorderQuantity, setReorderQuantity] = useState("")
  const [targetQuantity, setTargetQuantity] = useState("")
  const [reorderUnitQuantity, setReorderUnitQuantity] = useState("")

  useEffect(() => {
    setNote(article.note)
    setSerialNumber(article.serial_number)
    if (article.expiry_date) {
      setExpiryDate(moment(article.expiry_date))
    } else {
      setExpiryDate("")
    }
    const product = article.product
    if (product) {
      setReorderQuantity(formatOptionalNumber(product.reorder_quantity))
      setTargetQuantity(formatOptionalNumber(product.target_quantity))
      setReorderUnitQuantity(
        formatOptionalNumber(product.reorder_unit_quantity)
      )
    }
  }, [article])

  const submitExpiryDate = async () => {
    try {
      const payload = {
        article: {
          expiry_date: expiryDate,
          note: note,
          serial_number: serialNumber
        }
      }
      if (!article.is_singular_item) {
        payload.article.reorder_quantity = reorderQuantity || undefined
        payload.article.target_quantity = targetQuantity || undefined
        payload.article.reorder_unit_quantity = reorderUnitQuantity || undefined
      }
      const res = await Article.update(barcode, payload)
      history.push(`/article/${res.barcode}`)
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <div className="sh-detail-view">
      <div className="header">
        <div className="title">{t("articles.title")}</div>
      </div>

      <div style={{maxWidth: 550}}>
        <FormSection label={t("articles.details.data")}>
          <FieldDate
            label={t("articles.details.expiryDate")}
            name="expiry_date"
            defaultValue={expiryDate}
            onChange={setExpiryDate}
            width={"100%"}
          />

          <Field
            label={t("articles.details.serialNumber")}
            name="serial_number"
            defaultValue={serialNumber}
            onChange={e => setSerialNumber(e.target.value)}
          />

          {!article.is_singular_item && (
            <React.Fragment>
              <Field
                label={t("articles.details.reorderQuantity")}
                name="reorder_quantity"
                type="number"
                value={reorderQuantity}
                onChange={e => setReorderQuantity(e.target.value)}
              />
              <Field
                label={t("articles.details.targetQuantity")}
                name="target_quantity"
                type="number"
                value={targetQuantity}
                onChange={e => setTargetQuantity(e.target.value)}
              />
              <Field
                label={t("articles.details.reorderUnitQuantity")}
                name="reorder_unit_quantity"
                type="number"
                value={reorderUnitQuantity}
                onChange={e => setReorderUnitQuantity(e.target.value)}
              />
            </React.Fragment>
          )}
        </FormSection>
        <FormSection label={t("articles.details.noteLabel")}>
          <Field
            label={t("articles.details.note")}
            type="textarea"
            name="note"
            defaultValue={note}
            onChange={e => setNote(e.target.value)}
          />

          <div style={{display: "flex", justifyContent: "flex-end"}}>
            <Button
              style={{marginTop: 20, marginRight: 20}}
              secondary
              to={"/article/" + barcode}
              label={t("cancel")}
            />
            <Button
              style={{marginTop: 20}}
              primary
              onClick={() => submitExpiryDate()}
              label={t("save")}
            />
          </div>
        </FormSection>
      </div>
    </div>
  )
}

NewArticle.propTypes = {
  match: PropTypes.object.isRequired,
  usingTestDate: PropTypes.bool.isRequired
}

const mapStateToProps = ({auth}) => {
  const {
    user: {
      settings: {usingTestDate}
    }
  } = auth
  return {usingTestDate}
}

export default connect(mapStateToProps)(NewArticle)



// WEBPACK FOOTER //
// ./src/views/NewArticleView.js